(() => {
  if (window.__bhdNativeCartRewardsLoaded) return;
  window.__bhdNativeCartRewardsLoaded = true;

  let timer;

  const locale = (document.documentElement.lang || 'en').toLowerCase();
  const isSpanish = locale === 'es' || locale.startsWith('es-');

  const copy = isSpanish
    ? {
        heading: 'ARMA TU COMBO Y AHORRA',
        bundleLabel: 'AHORRO POR COMBO',
        shippingLabel: 'ENVÍO GRATIS',
        beforeMessage: 'Agrega {count} {item} más para obtener {discount}% de descuento',
        betweenMessage: 'Ya tienes {discount}% de descuento • agrega {count} más para llegar a {next_discount}%',
        maxMessage: 'Ya tienes {discount}% de descuento',
        shippingRemaining: 'Te faltan {amount} para obtener envío gratis',
        shippingUnlocked: '¡Ya tienes envío gratis!',
        itemOne: 'artículo',
        itemOther: 'artículos',
        discountSuffix: ' DE DESCUENTO',
      }
    : {
        heading: 'BUILD A BUNDLE & SAVE',
        bundleLabel: 'BUNDLE SAVINGS',
        shippingLabel: 'FREE SHIPPING',
        beforeMessage: 'Add {count} more {item} to unlock {discount}% off',
        betweenMessage: '{discount}% off unlocked • add {count} more for {next_discount}% off',
        maxMessage: '{discount}% off unlocked',
        shippingRemaining: '{amount} away from free shipping',
        shippingUnlocked: 'Free shipping unlocked',
        itemOne: 'item',
        itemOther: 'items',
        discountSuffix: '% OFF',
      };

  const number = (value, fallback = 0) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const bool = (value) => String(value) === 'true';

  const replaceTokens = (template, values) => {
    let output = template || '';
    Object.entries(values).forEach(([key, value]) => {
      output = output.split(`{${key}}`).join(String(value));
    });
    return output;
  };

  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(isSpanish ? 'es-MX' : locale || 'en-US', {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: cents % 100 ? 2 : 0,
        maximumFractionDigits: cents % 100 ? 2 : 0,
      }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(cents % 100 ? 2 : 0)}`;
    }
  };

  const ensureCheckoutButtonStyles = () => {
    if (document.getElementById('bhd-checkout-price-button-styles')) return;

    const style = document.createElement('style');
    style.id = 'bhd-checkout-price-button-styles';
    style.textContent = `
      .cart-drawer .button-container .bhd-checkout-price-button {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: .3rem !important;
        line-height: 1.08 !important;
      }

      .cart-drawer .bhd-checkout-price-button__main {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        gap: .42rem;
        width: 100%;
        white-space: nowrap;
      }

      .cart-drawer .bhd-checkout-price-button__label,
      .cart-drawer .bhd-checkout-price-button__separator,
      .cart-drawer .bhd-checkout-price-button__current {
        flex: 0 0 auto;
      }

      .cart-drawer .bhd-checkout-price-button__current {
        font-weight: 800;
      }

      .cart-drawer .bhd-checkout-price-button__shipping {
        display: block;
        font-size: .72em;
        font-weight: 800;
        line-height: 1;
        letter-spacing: .09em;
        text-transform: uppercase;
      }

      @media screen and (max-width: 749px) {
        .cart-drawer .button-container .bhd-checkout-price-button {
          min-height: 5.1rem;
          padding-top: .75rem !important;
          padding-bottom: .75rem !important;
        }

        .cart-drawer .bhd-checkout-price-button__main {
          gap: .36rem;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const getCheckoutLabel = (button) => {
    if (!button) return isSpanish ? 'PAGAR' : 'CHECK OUT';
    if (button.dataset.bhdCheckoutLabel) return button.dataset.bhdCheckoutLabel;

    const clone = button.cloneNode(true);
    clone.querySelectorAll(
      '.price, s, del, .bhd-checkout-price-button__shipping, .bhd-checkout-price-button__separator'
    ).forEach((element) => element.remove());

    const rawLabel = clone.textContent.replace(/\s+/g, ' ').trim();
    const label = rawLabel.replace(/\s*[—–-]+\s*$/, '').trim() || (isSpanish ? 'PAGAR' : 'CHECK OUT');
    button.dataset.bhdCheckoutLabel = label;
    return label;
  };

  const renderCheckoutButton = (root, total, currency, freeShippingUnlocked) => {
    const miniCart = root.closest('.mini-cart');
    if (!miniCart) return;

    const button = miniCart.querySelector('.button-container button[name="checkout"]');
    if (!button) return;

    ensureCheckoutButtonStyles();

    const label = getCheckoutLabel(button);
    const currentPriceText = formatMoney(total, currency);

    button.classList.add('bhd-checkout-price-button');
    button.dataset.bhdCheckoutLabel = label;
    button.textContent = '';

    const main = document.createElement('span');
    main.className = 'bhd-checkout-price-button__main';

    const labelElement = document.createElement('span');
    labelElement.className = 'bhd-checkout-price-button__label';
    labelElement.textContent = label;
    main.appendChild(labelElement);

    const separator = document.createElement('span');
    separator.className = 'bhd-checkout-price-button__separator';
    separator.setAttribute('aria-hidden', 'true');
    separator.textContent = '—';
    main.appendChild(separator);

    const current = document.createElement('span');
    current.className = 'price bhd-checkout-price-button__current';
    current.id = 'mini-cart-subtotal';
    current.textContent = currentPriceText;
    main.appendChild(current);

    button.appendChild(main);

    if (freeShippingUnlocked) {
      const shipping = document.createElement('span');
      shipping.className = 'bhd-checkout-price-button__shipping';
      shipping.textContent = isSpanish ? '+ ENVÍO GRATIS A EE. UU.' : '+ FREE U.S. SHIPPING';
      button.appendChild(shipping);
    }
  };

  const shippingGoal = (raw, currency) => {
    let fallback = 75;
    let exact = null;

    String(raw || '75')
      .replace(/\s+/g, '')
      .split(',')
      .filter(Boolean)
      .forEach((entry) => {
        const parts = entry.split(':');
        if (parts.length === 1 && Number.isFinite(Number(parts[0]))) {
          fallback = Number(parts[0]);
        } else if (parts.length === 2 && Number.isFinite(Number(parts[1]))) {
          if (parts[0].toUpperCase() === String(currency || '').toUpperCase()) {
            exact = Number(parts[1]);
          }
        }
      });

    return Math.max(0, Math.round((exact ?? fallback) * 100));
  };

  const config = () => {
    const element = document.querySelector('[data-bhd-cart-rewards-config]');
    if (!element) return null;
    const d = element.dataset;

    return {
      heading: d.heading || copy.heading,
      showBundle: bool(d.showBundle),
      showShipping: bool(d.showShipping),
      shippingAmounts: d.freeShippingAmounts || '75',
      bundleLabel: d.bundleLabel || copy.bundleLabel,
      shippingLabel: d.shippingLabel || copy.shippingLabel,
      beforeMessage: d.bundleMoreMessage || copy.beforeMessage,
      betweenMessage: d.bundleNextMessage || copy.betweenMessage,
      maxMessage: d.bundleMaxMessage || copy.maxMessage,
      shippingRemaining: d.shippingRemainingMessage || copy.shippingRemaining,
      shippingUnlocked: d.shippingUnlockedMessage || copy.shippingUnlocked,
      textColor: d.textColor || '#111111',
      accentColor: d.accentColor || '#006039',
      milestoneColor: d.milestoneColor || '#a37e2c',
      trackColor: d.trackColor || '#e0e0e0',
      tiers: [
        { quantity: number(d.tier1Quantity, 2), discount: number(d.tier1Discount, 15) },
        { quantity: number(d.tier2Quantity, 4), discount: number(d.tier2Discount, 20) },
        { quantity: number(d.tier3Quantity, 8), discount: number(d.tier3Discount, 25) },
      ]
        .filter((tier) => tier.quantity > 0)
        .sort((a, b) => a.quantity - b.quantity),
    };
  };

  const render = () => {
    const c = config();
    const roots = document.querySelectorAll('.cart-drawer .bhd-cart-rewards');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (!c) return;

      const count = Math.max(0, number(root.dataset.itemCount, 0));
      const total = Math.max(0, number(root.dataset.cartTotal, 0));
      const currency = root.dataset.currency || 'USD';
      let freeShippingUnlocked = false;

      root.style.setProperty('--bhd-rewards-text', c.textColor);
      root.style.setProperty('--bhd-rewards-accent', c.accentColor);
      root.style.setProperty('--bhd-rewards-milestone', c.milestoneColor);
      root.style.setProperty('--bhd-rewards-track', c.trackColor);

      const heading = root.querySelector('[data-bhd-rewards-heading]');
      if (heading) {
        const configured = c.heading.trim();
        heading.textContent = !configured || configured.toUpperCase() === 'BUNDLE + SHIPPING'
          ? copy.heading
          : configured;
      }

      const bundle = root.querySelector('[data-bhd-bundle]');
      if (bundle) {
        bundle.hidden = !c.showBundle || !c.tiers.length;
        if (!bundle.hidden) {
          const label = bundle.querySelector('[data-bhd-bundle-label]');
          if (label) label.textContent = c.bundleLabel;

          const maxTier = c.tiers[c.tiers.length - 1];
          const nextIndex = c.tiers.findIndex((tier) => count < tier.quantity);
          let message = '';
          let unlocked = false;

          if (nextIndex === 0) {
            const tier = c.tiers[0];
            const remaining = tier.quantity - count;
            message = replaceTokens(c.beforeMessage, {
              count: remaining,
              item: remaining === 1 ? copy.itemOne : copy.itemOther,
              discount: tier.discount,
            });
          } else if (nextIndex > 0) {
            const current = c.tiers[nextIndex - 1];
            const next = c.tiers[nextIndex];
            unlocked = true;
            message = replaceTokens(c.betweenMessage, {
              discount: current.discount,
              count: next.quantity - count,
              next_discount: next.discount,
            });
          } else {
            unlocked = true;
            message = replaceTokens(c.maxMessage, { discount: maxTier.discount });
          }

          const messageElement = bundle.querySelector('[data-bhd-bundle-message]');
          if (messageElement) {
            messageElement.textContent = message;
            messageElement.classList.toggle('is-unlocked', unlocked);
          }

          const fill = bundle.querySelector('[data-bhd-bundle-fill]');
          if (fill) {
            const progress = maxTier.quantity > 0 ? Math.min(100, (count / maxTier.quantity) * 100) : 100;
            fill.style.setProperty('--progress', `${progress}%`);
          }

          const milestones = bundle.querySelectorAll('[data-bhd-tier]');
          milestones.forEach((milestone, index) => {
            const tier = c.tiers[index];
            if (!tier) {
              milestone.hidden = true;
              return;
            }

            milestone.hidden = false;
            const position = maxTier.quantity > 0 ? Math.min(100, (tier.quantity / maxTier.quantity) * 100) : 100;
            milestone.style.setProperty('--milestone-position', `${position}%`);
            milestone.classList.toggle('is-reached', count >= tier.quantity);
            milestone.classList.toggle('is-last', index === c.tiers.length - 1);

            const quantity = milestone.querySelector('[data-bhd-tier-quantity]');
            if (quantity) quantity.textContent = String(tier.quantity);

            const discount = milestone.querySelector('[data-bhd-tier-discount]');
            if (discount) {
              discount.textContent = isSpanish
                ? `${tier.discount}%${copy.discountSuffix}`
                : `${tier.discount}${copy.discountSuffix}`;
            }
          });
        }
      }

      const shipping = root.querySelector('[data-bhd-shipping]');
      if (shipping) {
        shipping.hidden = !c.showShipping;
        if (!shipping.hidden) {
          const label = shipping.querySelector('[data-bhd-shipping-label]');
          if (label) label.textContent = c.shippingLabel;

          const goal = shippingGoal(c.shippingAmounts, currency);
          const unlocked = currency === 'USD' && (goal <= 0 || total >= goal);
          freeShippingUnlocked = unlocked;
          const message = unlocked
            ? c.shippingUnlocked
            : replaceTokens(c.shippingRemaining, { amount: formatMoney(Math.max(0, goal - total), currency) });

          const messageElement = shipping.querySelector('[data-bhd-shipping-message]');
          if (messageElement) {
            messageElement.textContent = message;
            messageElement.classList.toggle('is-unlocked', unlocked);
          }

          const fill = shipping.querySelector('[data-bhd-shipping-fill]');
          if (fill) {
            const progress = goal > 0 ? Math.min(100, (total / goal) * 100) : 100;
            fill.style.setProperty('--progress', `${progress}%`);
            fill.classList.toggle('is-complete', unlocked);
          }

          const milestone = shipping.querySelector('[data-bhd-shipping-milestone]');
          if (milestone) milestone.classList.toggle('is-reached', unlocked);

          const goalLabel = shipping.querySelector('[data-bhd-shipping-goal]');
          if (goalLabel) goalLabel.textContent = formatMoney(goal, currency);
        }
      }

      renderCheckoutButton(root, total, currency, c.showShipping && freeShippingUnlocked);
      root.hidden = (!c.showBundle || !c.tiers.length) && !c.showShipping;
    });
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(render, 50);
  };

  const observe = () => {
    const target = document.body || document.documentElement;
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) =>
        [...mutation.addedNodes, ...mutation.removedNodes].some((node) => {
          if (node.nodeType !== 1) return false;
          return node.matches?.('.bhd-cart-rewards, [data-bhd-cart-rewards-config], #mini-cart') ||
            node.querySelector?.('.bhd-cart-rewards, [data-bhd-cart-rewards-config], #mini-cart');
        })
      );
      if (relevant) schedule();
    });

    observer.observe(target, { childList: true, subtree: true });
  };

  const init = () => {
    observe();
    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
  document.addEventListener('cartdrawer:opened', schedule);
  document.addEventListener('cart:updated', schedule);
})();
